// Copyright © 2021 Move Closer
import { defineComponent } from '@vue/composition-api';
import { LinkContent, useLink } from '../../_abstract';
import { bootstrapLinkProps } from './Link.hooks';
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export const BootstrapLink = defineComponent({
    name: 'BootstrapLink',
    props: bootstrapLinkProps,
    components: { LinkContent },
    setup(props) {
        return useLink(props);
    },
    template: `
    <!-- External link OR Broken link target -->
    <component v-if="!hasCorrectTarget || external || disabled" :is="(!hasCorrectTarget || disabled) ? 'span' : 'a'"
               :class="{ 'text-muted': (!hasCorrectTarget || disabled) }" :rel="rel"
               v-bind="(!hasCorrectTarget || disabled) ? {} : { href: (target.path || target), target: aTarget }">
      <LinkContent v-bind="{ label }">
        <slot />
      </LinkContent>
    </component>
    <!-- END | External link -->

    <!-- In-app link -->
    <router-link v-else :to="target" :target="aTarget">
      <LinkContent v-bind="{ label }">
        <slot />
      </LinkContent>
    </router-link>
    <!-- END | In-app link -->
  `
});
